import { useEffect, useState } from "react";

// Mui Components
import { Icon, IconButton } from "@mui/material";

// Custom Components
import MDBox from "components/MDBox";
import Author from "components/Table/Author";

// Routing
import { useNavigate } from "react-router-dom";

// Utils
import { Icons, Common, Colors } from "utils/Constants";

export default function ProductSummaryData(
  productSummaryList,
  sorted,
  handleCategorySort,
  handleTypeSort
) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const handleInventoryView = (equipment) => {
    navigate(`/client/inventory-summary/inventory`, { state: { data: equipment } });
  };
  useEffect(() => {
    if (productSummaryList) {
      const list = productSummaryList?.map((item, index) => {
        const temp = {
          srNo: <Author name={index + 1} />,
          equipmentcategory: <Author name={item?.equipmentCategory} />,
          equipmenttype: <Author name={item?.equipmentType} />,
          totalStock: <Author name={item?.totalStock === 0 ? "-" : item?.totalStock} />,
          availableStock: <Author name={item?.availableStock === 0 ? "-" : item?.availableStock} />,
          atProject: <Author name={item?.atProject === 0 ? "-" : item?.atProject} />,
          inQuarantine: <Author name={item?.inQuarantine === 0 ? "-" : item?.inQuarantine} />,
          expCertificate: (
            <Author
              name={item?.totalExpiredCertificates === 0 ? "-" : item?.totalExpiredCertificates}
            />
          ),
          action: (
            <MDBox>
              <IconButton
                aria-label="fingerprint"
                color="info"
                onClick={() => handleInventoryView(item)}
              >
                {Icons.VIEW}
              </IconButton>
            </MDBox>
          ),
        };
        return temp;
      });
      setRows([...list]);
    }
  }, [productSummaryList]);

  return {
    columns: [
      { Header: "No.", accessor: "srNo", width: "3%" },
      {
        Header: () => (
          <div
            onClick={handleCategorySort}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleCategorySort()}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            Equipment Category
            <MDBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginLeft: "2px", lineHeight: 1 }}
            >
              <Icon
                fontSize="medium"
                sx={{
                  display: "block",
                  lineHeight: 1,
                  transform: "translateY(6px)",
                  color:
                    sorted.equipmentCategory === Common.ASC_KEY
                      ? Colors.WHITE
                      : "rgba(255,255,255,0.4)",
                  opacity: sorted.equipmentCategory === Common.ASC_KEY ? 1 : 0.5,
                }}
              >
                arrow_drop_up
              </Icon>
              <Icon
                fontSize="medium"
                sx={{
                  display: "block",
                  lineHeight: 1,
                  transform: "translateY(-6px)",
                  color:
                    sorted.equipmentCategory === Common.DESC_KEY
                      ? Colors.WHITE
                      : "rgba(255,255,255,0.4)",
                  opacity: sorted.equipmentCategory === Common.DESC_KEY ? 1 : 0.5,
                }}
              >
                arrow_drop_down
              </Icon>
            </MDBox>
          </div>
        ),
        accessor: "equipmentcategory",
        align: "left",
      },

      {
        Header: () => (
          <div
            onClick={handleTypeSort}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && handleTypeSort()}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            Equipment Type
            <MDBox
              display="flex"
              flexDirection="column"
              alignItems="center"
              sx={{ marginLeft: "2px", lineHeight: 1 }}
            >
              <Icon
                fontSize="medium"
                sx={{
                  display: "block",
                  lineHeight: 1,
                  transform: "translateY(6px)",
                  color:
                    sorted.equipmentType === Common.ASC_KEY
                      ? Colors.WHITE
                      : "rgba(255,255,255,0.4)",
                  opacity: sorted.equipmentType === Common.ASC_KEY ? 1 : 0.5,
                }}
              >
                arrow_drop_up
              </Icon>
              <Icon
                fontSize="medium"
                sx={{
                  display: "block",
                  lineHeight: 1,
                  transform: "translateY(-6px)",
                  color:
                    sorted.equipmentType === Common.DESC_KEY
                      ? Colors.WHITE
                      : "rgba(255,255,255,0.4)",
                  opacity: sorted.equipmentType === Common.DESC_KEY ? 1 : 0.5,
                }}
              >
                arrow_drop_down
              </Icon>
            </MDBox>
          </div>
        ),
        accessor: "equipmenttype",
        align: "left",
      },
      { Header: "Total Stock", accessor: "totalStock", align: "left", width: "8%" },
      { Header: "Ava. Stock", accessor: "availableStock", align: "left", width: "8%" },
      { Header: "At Project", accessor: "atProject", align: "left", width: "8%" },
      { Header: "In Quarantine", accessor: "inQuarantine", align: "left", width: "8%" },
      {
        Header: "Total Expired Certificates",
        accessor: "expCertificate",
        align: "left",
        width: "8%",
      },
      { Header: "Action", accessor: "action", width: "5%" },
    ],
    rows,
  };
}
